/** Accessibility helpers for tablists and view focus. */

type ActivateTabFn = (button: HTMLButtonElement) => void;

export function wireArrowKeyTablist(
  container: HTMLElement,
  buttonSelector: string,
  activate: ActivateTabFn
): void {
  container.addEventListener('keydown', (event) => {
    const target = event.target as HTMLElement | null;
    const current = target?.closest<HTMLButtonElement>(buttonSelector);
    if (!current) {
      return;
    }
    if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft' && event.key !== 'Home' && event.key !== 'End') {
      return;
    }
    const buttons = Array.from(container.querySelectorAll<HTMLButtonElement>(buttonSelector)).filter(
      (btn) => !btn.disabled
    );
    if (buttons.length === 0) {
      return;
    }
    const currentIndex = buttons.indexOf(current);
    if (currentIndex < 0) {
      return;
    }
    event.preventDefault();
    let nextIndex = currentIndex;
    if (event.key === 'ArrowRight') {
      nextIndex = (currentIndex + 1) % buttons.length;
    } else if (event.key === 'ArrowLeft') {
      nextIndex = (currentIndex - 1 + buttons.length) % buttons.length;
    } else if (event.key === 'Home') {
      nextIndex = 0;
    } else if (event.key === 'End') {
      nextIndex = buttons.length - 1;
    }
    const next = buttons[nextIndex];
    next.focus();
    activate(next);
  });
}

export function focusViewHeading(viewId: string): void {
  const view = document.getElementById(`view-${viewId}`);
  if (!view) {
    return;
  }
  const heading = view.querySelector<HTMLElement>('h1, h2, h3');
  if (!heading) {
    return;
  }
  if (!heading.hasAttribute('tabindex')) {
    heading.setAttribute('tabindex', '-1');
  }
  heading.focus();
}
